<template>
    <v-menu v-model="showPicker" :close-on-content-click="false" transition="scale-transition" offset-y
        min-width="auto">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateValue" :label="label" prepend-icon="mdi-calendar" readonly dense
                :outlined="outlined" v-bind="attrs" v-on="on" :rules="rules"></v-text-field>
        </template>
        <v-date-picker v-model="dateValue" @input="handleDateSelect" :min="minDate" :max="maxDate"
            :show-current="showCurrent" :show-today="showToday" :show-week="showWeek" :show-month="showMonth"
            :show-year="showYear" :type="type"></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'DefaultDatePicker',
    props: {
        value: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => []
        },
        minDate: {
            type: String,
            default: null
        },
        maxDate: {
            type: String,
            default: null
        },
        showCurrent: {
            type: Boolean,
            default: true
        },
        showToday: {
            type: Boolean,
            default: true
        },
        showWeek: {
            type: Boolean,
            default: true
        },
        showMonth: {
            type: Boolean,
            default: true
        },
        showYear: {
            type: Boolean,
            default: true
        },
        showWeekNumbers: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'date',
            validator: (value) => {
                return ['date', 'year', 'month'].includes(value);
            }
        }
    },
    data() {
        return {
            showPicker: false,
            dateValue: this.value
        }
    },
    watch: {
        value(newValue) {
            this.dateValue = newValue;
        },
        dateValue(newValue) {
            this.$emit('input', newValue);
        }
    },
    methods: {
        handleDateSelect(date) {
            this.showPicker = false;
        }
    }
}
</script>